import styled, { css } from 'styled-components';
import { Button } from '../Button/Button';
import { getBGColor } from '../Button/Button.styles';
import { Card } from '../Card/Card';
import { Spinner } from '../Spinner/Spinner';
export var StyledDropdownMenu = /*#__PURE__*/styled(Card).withConfig({
  displayName: "StyledDropdownMenu",
  componentId: "core-12_15_0__sc-ufsy2q-0"
})(["display:flex;max-height:40vh;max-width:248px;min-width:inherit;"]);
export var StyledDropdownSpinner = /*#__PURE__*/styled(Spinner).withConfig({
  displayName: "StyledDropdownSpinner",
  componentId: "core-12_15_0__sc-ufsy2q-1"
})(["margin:0 6px;"]);
export var StyledDropdownButton = /*#__PURE__*/styled(Button).withConfig({
  displayName: "StyledDropdownButton",
  componentId: "core-12_15_0__sc-ufsy2q-2"
})(["pointer-events:", ";", ""], function (_ref) {
  var disabled = _ref.disabled,
    $loading = _ref.$loading;
  return disabled || $loading ? 'none' : 'inherit';
}, function (_ref2) {
  var $loading = _ref2.$loading,
    variant = _ref2.variant;
  if ($loading) {
    return css(["background:", ";"], getBGColor(variant).hover);
  }
});
//# sourceMappingURL=Dropdown.styles.js.map